import React from 'react';
import { Navigate } from 'react-router-dom';

const DefaultRedirect = () => {
  return <Navigate to="/main" />;
};

export default DefaultRedirect;